import React, { forwardRef, memo } from "react";
import { BadgeCounterProps } from "../../types";
import { calculateBadgeWidth } from "../../utils";
import { BadgeContainer, BadgeText } from "./styled-components";
import { useQaLabel } from "../../../../../src";

export const BadgeCounter = memo(
  forwardRef<HTMLDivElement, BadgeCounterProps>(
    (
      {
        qaLabel = "badge",
        counter,
        counterLimit = 99,
        variant = "primary",
        accessibilityLabel,
        ...rest
      }: BadgeCounterProps,
      ref
    ) => {
      const viewTestProps = useQaLabel(qaLabel);
      const valueOfNotifications =
        counterLimit && counter > counterLimit ? `${counterLimit}+` : counter;

      return (
        <BadgeContainer
          {...viewTestProps}
          variant={variant}
          aria-label={
            accessibilityLabel || `${valueOfNotifications} notifications`
          }
          badgeWidth={calculateBadgeWidth(counter, counterLimit)}
          // @ts-ignore
          ref={ref}
          isCircle={String(valueOfNotifications).length === 1}
          {...rest}
        >
          <BadgeText>{valueOfNotifications}</BadgeText>
        </BadgeContainer>
      );
    }
  )
);
